import React, { useEffect, useState } from 'react';
import styles from './MajorCard.module.scss';
import Text from '../../atoms/text/Text';
const forAll = '/assets/svg/degrees/forAll.svg';

const cadets = '/assets/svg/degrees/cadets.svg';

import { useNavigate } from 'react-router-dom';
import getCookie from '../../../app/helpers/getCookie';

const MajorCard = ({
  title,
  titleEN,

  id,
  isCadet,
}) => {
  const navigate = useNavigate();
  const [isEnglish, setIsEnglish] = useState(false);
  const cookieVal = getCookie('googtrans');

  useEffect(() => {
    if (cookieVal?.includes('/ar/en')) {
      setIsEnglish(true);
    }
  }, [cookieVal]);

  const navigateTo = () => {
    const formattedName = titleEN?.replace(/\s+/g, '-').toLowerCase();
    navigate(`/degree-programs/degree/${formattedName}/${id}`);
  };
  return (
    <div className={`${styles['major-card']} `} onClick={navigateTo}>
      <img src={isCadet ? cadets : forAll} alt="" />
      <Text
        title={title}
        variant="text-regular-14"
        maxLines={2}
        centered
        className={styles.title}
      />
      <Text
        title={
          isCadet === 1
            ? isEnglish
              ? 'Cadets'
              : 'home.students_cadet'
            : isEnglish
              ? 'For All'
              : 'home.forAll'
        }
        variant="text-regular-14"
        className={`${styles['text-view']}`}
      />
    </div>
  );
};

export default MajorCard;
